// ============================================================
// Income Service Layer
// ============================================================

import { incomesApi } from '@/api/incomes.api';

export const incomeService = {
  // Categories
  getCategories: async (schoolId, includeInactive = false) => {
    return await incomesApi.getCategories(schoolId, includeInactive);
  },

  createCategory: async (schoolId, payload) => {
    return await incomesApi.createCategory(schoolId, payload);
  },

  updateCategory: async (schoolId, id, payload) => {
    return await incomesApi.updateCategory(schoolId, id, payload);
  },

  deleteCategory: async (schoolId, id) => {
    return await incomesApi.deleteCategory(schoolId, id);
  },

  // Incomes
  getIncomes: async (schoolId, params = {}) => {
    return await incomesApi.getIncomes(schoolId, params);
  },

  getIncomeById: async (schoolId, id) => {
    return await incomesApi.getIncomeById(schoolId, id);
  },

  createIncome: async (schoolId, payload) => {
    return await incomesApi.createIncome(schoolId, payload);
  },

  updateIncome: async (schoolId, id, payload) => {
    return await incomesApi.updateIncome(schoolId, id, payload);
  },

  deleteIncome: async (schoolId, id) => {
    return await incomesApi.deleteIncome(schoolId, id);
  },

  getSummaryTotal: async (schoolId, params = {}) => {
    return await incomesApi.getSummaryTotal(schoolId, params);
  },
};
